export const lightTheme = {
	components: {
		Layout: {
			headerHeight: 60,
			headerBg:"#e9f0f7",
			siderBg:"#d1ddeb",
			bodyBg:"#e9f0f7",
		},
		Menu: {
			activeBarBorderWidth:0,
			itemBg:"#d1ddeb",
			itemHeight:60,
			iconSize:17,
			itemHoverBg:"#a2bdde",
			itemColor:"#595959",
			itemSelectedBg:"#a2bdde",
			itemSelectedColor:"#000000",
			subMenuItemBg:"#e9f0f7",
		},
		Input:{
			borderRadius:"10px",
			activeBorderColor:"#d1ddeb",
			colorBorder:"#d1ddeb",
			colorBgContainerDisabled:"#e9f0f7",
		},
		Cascader:{
			borderRadius:"10px",
			activeBorderColor:"#d1ddeb",
			colorBorder:"#d1ddeb",
		},
		Select:{
			borderRadius:"10px",
			activeBorderColor:"#d1ddeb",
			colorBorder:"#d1ddeb",
			colorBgContainerDisabled: "#e9f0f7"
		},
		Button:{
			borderRadius:"10px",
			activeBorderColor:"#d1ddeb",
			colorBorder:"#d1ddeb",
			colorBgContainerDisabled:"#e9f0f7",
		},
		DatePicker:{
			borderRadius:"10px",
			activeBorderColor:"#d1ddeb",
			colorBorder:"#d1ddeb",
		},
		Result:{
			colorInfo:"#2d5db7"
		},
		Form:{
			margin:10,
			itemMarginBottom:10
		},
		Table:{
			borderColor:"#e9f0f7",
			headerBg:"#e9f0f7",
			footerBg:"#e9f0f7",
			headerFilterHoverBg: "#d1ddeb",
			headerSortActiveBg: "#d1ddeb",
			headerSortHoverBg: "#d1ddeb",
			rowHoverBg: "#e7e7e7",
			cellPaddingBlockSM:4,
			cellPaddingInlineSM:2,
		},
		Divider: {
			lineWidth:2
		},
		Checkbox: {
			colorBgContainer: "#e9f0f7"
		},
		Descriptions: {
			colorTextTertiary: "black",
		},
		Card: {
			borderColor: "#ff0404",
		},
		Tag: {			
			colorText: "black",
		}
	},
	token: {
		colorPrimary: "#2d5db7",
		colorPrimaryActive : "#2d5db7",
		colorBgLayout: "#e9f0f7",
		borderRadius: "10px",
		lineWidth:1.5,
		controlItemBgHover: "#e9f0f7",
		controlItemBgActive: "#a2c0e3",
		colorBorder:"#e9f0f7",
		colorSplit: "#e9f0f7",
		colorBgBase: "#ffffff",
		colorBorderSecondary: "#e9f0f7",
		colorBgContainerDisabled: "#e9f0f7",
		colorSelectedRowTable: "rgb(196, 217, 226)",
		colorRed: "red",
		colorYellow: "#f3cd27",
	},
};

export const darkTheme = {
	components: {
		Layout: {
			headerHeight: 60,
			headerBg: "#202325",
			siderBg: "#2B2E30",
			bodyBg: "#202325",
		},
		Menu: {
			activeBarBorderWidth: 0,
			itemBg: "#2B2E30",
			itemHeight: 60,
			iconSize: 17,
			itemHoverBg: "#213C5D",
			itemColor: "whitesmoke",
			itemSelectedBg: "#213C5D",
			itemSelectedColor: "whitesmoke",
			subMenuItemBg: "#202325",
			itemHoverColor: "white",
		},
		Input: {
			borderRadius: "10px",
			activeBorderColor: "#7D7467",
			colorBorder: "#2B2E30",
			colorBgContainerDisabled: "#202325",
		},
		Cascader: {
			borderRadius: "10px",
			activeBorderColor: "#2B2E30",
			colorBorder: "#2B2E30",
			optionSelectedBg: "#213C5D",
		},
		Select: {
			borderRadius: "10px",
			activeBorderColor: "#2B2E30",
			colorBorder: "#2B2E30",
			colorBgContainerDisabled: "#202325",
			clearBg: "#181a1b",
			selectorBg: "#181a1b",
			colorText: "whitesmoke",
			optionSelectedBg: "#213C5D",
		},
		Button: {
			borderRadius: "10px",
			activeBorderColor: "#2B2E30",
			colorBorder: "#2B2E30",
			colorBgContainerDisabled: "#202325",
			primaryShadow: "#2B2E30",
			dangerShadow: "#2B2E30",
			colorTextDisabled: "gray",
		},
		DatePicker: {
			borderRadius: "10px",
			activeBorderColor: "#2B2E30",
			colorBorder: "#2B2E30",
			cellActiveWithRangeBg: "#2B2E30",
			colorTextDisabled: "gray",
		},
		Result: {
			colorInfo: "#2d5db7",
		},
		Form: {
			margin: 10,
			itemMarginBottom: 10,
		},
		Table: {
			borderColor: "#202325",
			headerBg: "#202325",
			footerBg: "#202325",
			headerFilterHoverBg: "#2B2E30",
			headerSortActiveBg: "#2B2E30",
			headerSortHoverBg: "#2B2E30",
			rowHoverBg: "#202325",
		},
		Divider: {
			lineWidth: 2,
		},
		Checkbox: {
			colorBgContainer: "#202325",
			colorBorder: "#2d5db7",
		},
		Descriptions: {
			colorTextTertiary: "whitesmoke",
		},
		Card: {
			borderColor: "#ff0404",
		},
		Tag: {			
			colorText: "whitesmoke",
		}
	},
	token: {
		colorPrimary: "#2d5db7",
		colorPrimaryActive: "#2d5db7",
		colorBgLayout: "#202325",
		borderRadius: "10px",
		lineWidth: 1.5,
		controlItemBgHover: "#202325",
		controlItemBgActive: "rgb(58, 70, 75)",
		colorBorder: "#202325",
		colorSplit: "#202325",
		colorBgContainer: "#181a1b",
		colorBgBase: "#181a1b",
		colorTextPlaceholder: "gray",
		colorText: "whitesmoke",
		colorTextDescription: "#7d7467",
		colorIcon: "whitesmoke",
		colorTextLabel: "whitesmoke",
		colorBorderSecondary: "#202325",
		colorTextDisabled: "gray",
		colorTextTertiary: "whitesmoke",		
		colorSelectedRowTable: "rgb(58, 70, 75)",
		colorRed: "#cf0c0c",
		colorYellow: "#cba500",
	},
};
